module.exports = __webpack_public_path__ + "static/img/Partner18@2x.edabcdce.png";